// @source https://gitlab.iris-interactive.fr/wordpress/otvaldegaronne/theme_customer_otvaldegaronne/-/blob/master/resources/assets/scripts/components/map-home.component.js
export default class MapHomeComponent {
    static isAjaxRunning = false

    constructor() {
        if ($('.strate--map').length > 0) {
            MapHomeComponent.onDesktop()

            if (window.matchMedia('(max-width: 1000px)').matches) {
                window.addEventListener('resize', MapHomeComponent.onDesktop)
            }
        }
    }

    static onDesktop() {
        if (window.matchMedia('(min-width: 1000px)').matches) {
            window.removeEventListener('resize', MapHomeComponent.onDesktop)

            const mapWrapper = '[data-element="svg-map"]'

            $.ajax({
                url: IRISCollectionCustomer.ajaxUrl,
                type: 'post',
                data: {
                    action: 'get_svg_map_home',
                    datas: {
                        homepageId: $('.strate--map').data('homepage-id'),
                        currentLang: $('html').attr('lang'),
                    },
                },
                success: (result) => {
                    $(mapWrapper).fadeOut(250, () => {
                        $(mapWrapper).removeClass('loading')
                        $(mapWrapper).html(result)
                        $(mapWrapper).fadeIn(250)
                    })
                },
                error: (request, status, error) => {
                    console.error(request.responseText, error)
                },
            })
        }
    }
}
